import React, { useContext } from 'react';
import leaderDailyImg from './cards/leader_daily.png';
import leaderWeeklyImg from './cards/leader_weekly.png';
import leaderTournamentImg from './cards/leader_tournament.png';
import leaderBcsImg from './cards/leader_bcs.png';
import { dataContext } from '../../App';

export default function NewLeaderboard({ setShowNewLeaderboardModal }) {
  const { setActiveLeaderboardName } = useContext(dataContext);

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', padding:'16px' }}>
        <img src={leaderDailyImg} onClick={()=>{setShowNewLeaderboardModal(true);setActiveLeaderboardName('leaderboard_daily')}} alt="" style={{ width: '100%', maxWidth: '100%',borderRadius:'6px', cursor:'pointer' }} />
        <img src={leaderWeeklyImg} onClick={()=>{setShowNewLeaderboardModal(true);setActiveLeaderboardName('leaderboard_weekly')}} alt="" style={{ width: '100%', maxWidth: '100%',borderRadius:'6px', cursor:'pointer' }} />
        <img src={leaderTournamentImg} onClick={()=>{setShowNewLeaderboardModal(true);setActiveLeaderboardName('leaderboard_tournament')}} alt="" style={{ width: '100%', maxWidth: '100%',borderRadius:'6px', cursor:'pointer' }} />
        <img src={leaderBcsImg} onClick={()=>{setShowNewLeaderboardModal(true);setActiveLeaderboardName('leaderboard_bcs')}} alt="" style={{ width: '100%', maxWidth: '100%',borderRadius:'6px', cursor:'pointer' }} />
      </div>
    </>
  );
};
